import { Dispatch } from 'react'
import { useQuery } from 'react-query'
import { ErrorResponse } from '@citruscamps/citrus-client'
import { HttpClient } from '../../../../../utils/http'
import { useLocalStorage } from '../../../../../hooks/useLocalStorage'

interface IProps {
  contentId?: string
}
export interface ConfluenceContent {
  id: string
  type: string
  parent_id?: string
  status: string
  title: string
  summary: string
  body?: string
  children?: ConfluenceContent[]
  created?: Date
  created_by?: string
}

interface FetchConfluenceContent {
  data?: ConfluenceContent
  lastViewedOn?: Date
  isLoading: boolean
  isError: boolean
  error: ErrorResponse | null
  setLastViewedOn: Dispatch<Date | undefined>
}

export const useFetchConfluenceContent = ({ contentId = '' }: IProps): FetchConfluenceContent => {
  const [lastViewedOn, setLastViewedOn] = useLocalStorage<Date | undefined>(
    'whats-new-lasted-viewed',
    undefined,
  )
  const queryKeys = ['whats-new', contentId]
  const { isLoading, isError, data, error } = useQuery<ConfluenceContent, ErrorResponse>(
    queryKeys,
    async ({ signal }) => {
      const client = new HttpClient({ baseUrl: process.env.REACT_APP_CONFLUENCE_API_URL || '' })
      return await client.get<ConfluenceContent>(
        `/api/v1/content${contentId ? `?content_id=${contentId}` : ''}`,
        { signal },
      )
    },
  )

  return {
    data,
    lastViewedOn: lastViewedOn ? new Date(lastViewedOn) : undefined,
    isLoading,
    isError,
    error,
    setLastViewedOn,
  }
}
